$(document).ready(function () {
  // Toggle custom start/end date fields when the timeline dropdown changes to/from 'Custom'
  $(document).on('change', '.report-exporters-director-won-deals-report-component .selected-timeline-js', function () {
    const dateFields = $(this).closest('.report-exporters-director-won-deals-report-component').find('.custom-timeline-dropdowns-js');

    if ($(this).val() === 'Custom') {
      dateFields.removeClass('d-none');
    } else {
      dateFields.addClass('d-none');
    }
  });
});
